import { BehaviorSubject } from 'rxjs';
import { addError, clearError } from './Error';
import { getCustomerAttributions } from '../Api/Attribution/AttributionApi';

export interface CustomerAttribution {
  id: string;
  tallyRunId: number;
  runDate: string;
  runStatus: string;
  chargeRecurringExpected: number | null;
  chargeRecurringActual: number | null;
  revenueRecurringExpected: number | null;
  revenueRecurringActual: number | null;
  revenueRecurringNetActual: number | null;
  revenueRecurringCorrection: number | null;
  revenueOnetimeExpected: number | null;
  revenueOnetimeActual: number | null;
  revenueOnetimeNetActual: number | null;
  revenueOnetimeCorrection: number | null;
  revenueTrueupExpected: number | null;
  revenueTrueupActual: number | null;
  revenueTrueupDifference: number | null;
  revenueSpiffExpected: number | null;
  revenueSpiffActual: number | null;
}

export interface ResponseCustomerAttributionRecord {
  customerId: string;
  supplierId?: string;
  attributions: CustomerAttribution[];
}

const attributionSubject = new BehaviorSubject<ResponseCustomerAttributionRecord | null>(null);
const attributionLoadingSubject = new BehaviorSubject<boolean>(false);

export const getCustomerAttributionSubject = (): BehaviorSubject<ResponseCustomerAttributionRecord | null> =>
  attributionSubject;
export const getCustomerAttributionLoadingSubject = (): BehaviorSubject<boolean> => attributionLoadingSubject;

export const fetchCustomerAttributions = async (customerId: string, supplierId?: string, forceRefresh = false) => {
  const currentValue = attributionSubject.getValue();
  if (
    (!forceRefresh && currentValue && currentValue.customerId == customerId && currentValue.supplierId == supplierId) ||
    (forceRefresh && currentValue?.customerId != customerId && currentValue?.supplierId != supplierId)
  ) {
    return;
  }
  attributionLoadingSubject.next(true);

  const { data, error } = await getCustomerAttributions(customerId, supplierId);

  if (data) {
    clearError('attribution');
    attributionSubject.next(data);
  }
  if (error) addError('attribution', error.message);

  attributionLoadingSubject.next(false);
};
